var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestionMark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 15,
    fill: "none",
    viewBox: "0 0 9 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F5F7FA",
    d: "M0 4.102c0-.378.052-.756.156-1.133.11-.378.283-.746.518-1.104.234-.358.517-.674.85-.947.338-.28.755-.501 1.25-.664C3.273.084 3.821 0 4.413 0 5.091 0 5.71.114 6.27.342c.566.228 1.028.53 1.386.908.365.378.645.807.84 1.29.202.474.303.97.303 1.483 0 1.4-.68 2.559-2.041 3.477l-.918.625c-.586.397-.88 1.035-.88 1.914 0 .124.007.25.02.38H3.213c-.013-.162-.02-.393-.02-.692 0-.671.13-1.26.391-1.768.267-.514.69-.967 1.27-1.357l.878-.596c.339-.228.6-.514.782-.86.188-.345.283-.712.283-1.103 0-.638-.208-1.178-.625-1.621-.41-.443-.996-.664-1.758-.664-.553 0-1.025.13-1.416.39-.384.254-.66.57-.83.948-.17.377-.254.787-.254 1.23 0 .371.049.697.147.977L.117 5.059C.04 4.779 0 4.459 0 4.102zm2.773 9.18c0-.365.127-.675.381-.928.254-.26.56-.391.918-.391.365 0 .677.13.938.39.26.26.39.57.39.928 0 .358-.13.664-.39.918s-.573.381-.938.381c-.358 0-.664-.127-.918-.38-.254-.255-.38-.56-.38-.919z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "static/media/QuestionMark.9659528c.svg";
export { ForwardRef as ReactComponent };